import React from 'react';

import { ModalTransition } from '@atlaskit/modal-dialog';

import { useChoreographerAssets } from '@confluence/choreographer-services/entry-points/useChoreographerAssets';

import type { SpaceSelection } from '../page-components/SpaceSelectionRadioButtons';
import { LoadingDialog } from '../space-permissions-dialog/LoadingDialog';

import { ChangeConfirmationDialog } from './ChangeConfirmationDialog';

export const BulkAccessModal = ({
	principalName,
	roleName,
	isLoading,
	isRemoval,
	spaceSelection,
	onCancel,
	onConfirm,
}: {
	principalName: string;
	roleName?: string;
	isLoading: boolean;
	isRemoval: boolean;
	spaceSelection: SpaceSelection;
	onCancel: () => void;
	onConfirm: () => void;
}) => {
	const { Modal } = useChoreographerAssets();
	return (
		<ModalTransition>
			<Modal
				testId="bulk-access-confirmation"
				onClose={
					// Don't allow the dialog to close while mutation is loading
					isLoading ? undefined : onCancel
				}
			>
				{isLoading ? (
					<LoadingDialog />
				) : (
					<ChangeConfirmationDialog
						principalName={principalName}
						roleName={roleName}
						isRemoval={isRemoval}
						spaceSelection={spaceSelection}
						onCancel={onCancel}
						onConfirm={onConfirm}
					/>
				)}
			</Modal>
		</ModalTransition>
	);
};
